import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import { getDirectionClass } from '../utils/classname';
import List from '../AnimationList';
import Tree from '../Tree';
import Spin from '../Spin';
import { getLocale } from '../locale';
import { selectClass } from './styles';
import { getCustomList } from './utils';
var ScaleList = List(['fade', 'scale-y'], 'fast');
var DATA_PATH_KEY = '$PATH';

var OptionList =
/*#__PURE__*/
function (_Component) {
  _inherits(OptionList, _Component);

  var _super = _createSuper2(OptionList);

  function OptionList(props) {
    var _this;

    _classCallCheck(this, OptionList);

    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OptionList, [{
    key: "getText",
    value: function getText(key) {
      return this.props.text && this.props.text[key] || getLocale(key);
    }
  }, {
    key: "handleClick",
    value: function handleClick(data, _, p) {
      var path = p.path;
      var _this$props = this.props,
          datum = _this$props.datum,
          onChange = _this$props.onChange;
      if (datum.disabled(data)) return;
      onChange(null, _objectSpread2(_objectSpread2({}, data), {}, _defineProperty({}, DATA_PATH_KEY, path)));
    }
  }, {
    key: "renderItem",
    value: function renderItem(data) {
      var _this$props2 = this.props,
          renderItem = _this$props2.renderItem,
          datum = _this$props2.datum;
      var content = renderItem(data);
      return (
        /*#__PURE__*/
        React.createElement("span", {
          title: typeof content === 'string' ? content : undefined,
          className: selectClass('tree-node', datum.check(data) && 'selected', datum.disabled(data) && getDirectionClass('disabled'))
        }, content)
      );
    }
  }, {
    key: "renderTree",
    value: function renderTree() {
      var _this$props3 = this.props,
          loading = _this$props3.loading,
          treeData = _this$props3.treeData,
          keygen = _this$props3.keygen,
          onExpand = _this$props3.onExpand,
          loader = _this$props3.loader,
          expanded = _this$props3.expanded,
          defaultExpanded = _this$props3.defaultExpanded,
          defaultExpandAll = _this$props3.defaultExpandAll,
          renderPending = _this$props3.renderPending,
          childrenKey = _this$props3.childrenKey,
          expandIcons = _this$props3.expandIcons,
          emptyText = _this$props3.emptyText;
      if (loading) return (
        /*#__PURE__*/
        React.createElement("span", {
          className: selectClass(getDirectionClass('option'))
        }, typeof loading === 'boolean' ?
        /*#__PURE__*/
        React.createElement(Spin, {
          size: 20
        }) : loading)
      );
      if (treeData.length === 0 || renderPending) return (
        /*#__PURE__*/
        React.createElement("span", {
          className: selectClass(getDirectionClass('option'))
        }, emptyText || this.getText('noData'))
      );
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: selectClass('tree-wrapper')
        },
        /*#__PURE__*/
        React.createElement(Tree, {
          radioUpdate: true,
          onClick: this.handleClick,
          line: false,
          data: treeData,
          keygen: keygen,
          renderItem: this.renderItem.bind(this),
          onExpand: onExpand,
          loader: loader,
          expanded: expanded,
          defaultExpandAll: defaultExpandAll,
          defaultExpanded: defaultExpanded,
          childrenKey: childrenKey,
          expandIcons: expandIcons
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          focus = _this$props4.focus,
          style = _this$props4.style,
          selectId = _this$props4.selectId,
          height = _this$props4.height,
          getRef = _this$props4.getRef,
          customHeader = _this$props4.customHeader,
          renderOptionList = _this$props4.renderOptionList,
          loading = _this$props4.loading;
      var mergeStyle = Object.assign({}, {
        maxHeight: height,
        overflowY: 'auto'
      }, style);
      var result =
      /*#__PURE__*/
      React.createElement(React.Fragment, null, customHeader, this.renderTree());
      return (
        /*#__PURE__*/
        React.createElement(ScaleList, {
          getRef: getRef,
          show: focus,
          style: mergeStyle,
          "data-id": selectId,
          className: selectClass('options', 'tree')
        }, getCustomList(result, renderOptionList, loading))
      );
    }
  }]);

  return OptionList;
}(Component);

export default OptionList;